// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tc-timeframe-portal.dark .dropdown-item{color:#edf2fa}.tc-timeframe-portal .dropdown-item:hover,.tc-timeframe-portal .dropdown-active{color:#2864F0!important;background:#2864F018!important}", ""]);
// Exports
module.exports = exports;
